// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"4f5f5e3a","340":"4f5f5e3a","346":"4f5f5e3a","582":"e1999597","937":"4f5f5e3a"}[chunkId] + ".chunk.css";
};